import React from 'react';
import { ImThemeProvider, ImThemeProviderZenith } from '@im/im-theme';
import { MuiProviders } from '@im/ui-lib/theme/MuiProviders';
import { useStorefrontInfo } from '../../x4ec/provider/storefront-info';
import { XvAppId } from '@im/ui-lib/mf-utils';

type ThemeProviderProps = {
  children: React.ReactNode;
};

function X4CThemeProvider(props: Readonly<ThemeProviderProps>) {
  const { children } = props;
  return (
    <ImThemeProvider>
      <MuiProviders>{children}</MuiProviders>
    </ImThemeProvider>
  );
}

function X4ECThemeProvider(props: Readonly<ThemeProviderProps>) {
  const { children } = props;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const storefrontInfo = useStorefrontInfo();

  return (
    <ImThemeProviderZenith themeName={'im-light'}>
      <MuiProviders>{children}</MuiProviders>
    </ImThemeProviderZenith>
  );
}

export function ThemeProvider(
  props: Readonly<ThemeProviderProps & { appId: XvAppId }>
) {
  const { appId, children } = props;

  const providerMap: { [appName: string]: React.FC<ThemeProviderProps> } = {
    cep: X4CThemeProvider,
    x4ec: X4ECThemeProvider,
  };

  const Provider = providerMap[appId];

  return <Provider>{children}</Provider>;
}
